import React from 'react'
import styled from 'styled-components'

import FighterIcon from '../../assets/images/fighter-icon.png'
import BLogo from '../../assets/images/binance-logo.png'
import './Footer.css'
// eslint-disable-next-line
import FooteLinkIcon from '../../assets/images/footerLink_icon.png'
const Link02: React.FC = () => {
    return (
        <FLink02B>
        {/* <StyledAbsoluteLinkB href="https://www.metadatacity.com/" target="_blank">Powered by MetaDataCity</StyledAbsoluteLinkB> |
        <StyledAbsoluteLinkB href="https://www.metacians.com/" target="_blank">Metacians Platform</StyledAbsoluteLinkB> |
        <StyledAbsoluteLinkB href="https://www.metacians.com/nft-games/" >Metacians Gaming</StyledAbsoluteLinkB> |
        <StyledAbsoluteLinkB href="https://www.metacians.com/nft-arts/" >Metacians Staking</StyledAbsoluteLinkB> | |
        <StyledAbsoluteLinkB href="https://www.metacians.com/utility-projects/">Metacians Trading</StyledAbsoluteLinkB> |
        <StyledAbsoluteLinkB href="https://www.metacians.com/investment-opportunities/">Metacians Invest</StyledAbsoluteLinkB> |
    <StyledAbsoluteLinkB href="#" >Metacians Hub</StyledAbsoluteLinkB>*/}

        </FLink02B>
    )
}

const Link01: React.FC = () => {
    return (
      <FLink01B>
        {/* <StyledAbsoluteLinkA href="#" >List new token</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Back to v1</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Voting</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Github</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Medium</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Telegram</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA href="#" >Twitter</StyledAbsoluteLinkA> |
        <StyledAbsoluteLinkA className="pool" >Discord</StyledAbsoluteLinkA> |
    <StyledIcon01 href="#"></StyledIcon01> */}
      </FLink01B>
    )
}
// eslint-disable-next-line
const StyledAbsoluteLinkA = styled.a`
    cursor:pointer; 
    text-decoration: none;
    color:#fff;
    font:normal 10px/16px "Press Start 2P", arial;
    margin:0 16px;
    &:hover {
        color: #F3B92E;
    }
`
// eslint-disable-next-line
const StyledAbsoluteLinkB = styled.a`
    cursor:pointer; 
    text-decoration: none;
    color:#fff;
    font:normal 12px/16px "IBM Plex Mono", arial;
    margin:0 6px;
    &:hover {
        color: #F3B92E;
    }
`

const FooterFrame = styled.footer`

    background-color:#070707;
    width:100%;
    height:20px; 
    margin-top:40px;
    display:flex;
    align-items:center;
    padding:28px 20px;
    flex-wrap:wrap;
    position:relative;
    @media (min-width: 320px) and (max-width: 500px){
        flex-wrap: wrap;
        flex-direction: row;
    }
    @media (min-width: 501px) and (max-width: 767px){
        height:auto;
        padding:10px 10px 30px 10px;
    }
    @media (min-width: 768px) and (max-width: 991px){
        height:auto;
        padding:10px 10px 30px 10px;
    } 
`

const JRLogo = styled.div`
    margin-right:auto;
    min-width:110px;

    @media (min-width: 320px) and (max-width: 500px){
        margin:0 auto 20px auto;
    }
`

const FooterCbox = styled.div`
    text-align:center;
    margin:0 auto;
`

const FLink01B = styled.div`
    font:normal 15px/16px arial;color:#424242;
    padding-bottom:8px;
    display:flex;
    align-items:center;
    justify-content:center;
`

const FLink02B = styled.div`
    font:normal 15px/16px arial;color:#2a2a2a;
    padding-bottom:8px;
`

const BinanceLogo = styled.div`
    margin-left:auto;
    @media (min-width: 220px) and (max-width: 400px){
        margin:0 auto 20px auto;
    }
`

const BinanceLogoLink = styled.a`
    &:hover {
        opacity:0.7;
    }
`

const FooterBody = styled.div`
    display:block;
    margin: 8px;
    width:99%;
    position: fixed;
    left: 0;
    bottom: 0;
    

`
const Footer: React.FC = () => {
    
    return (
        <FooterBody>
            <FooterFrame>
                <JRLogo>
                  <img style={{ position: 'absolute', left:20, top:10,  width:40, height:40 }} src={FighterIcon} alt="Fighter" />
                </JRLogo>
                <FooterCbox>
                    <Link01 />
                    <Link02 />
                </FooterCbox>
                <BinanceLogo>
                <BinanceLogoLink href="https://www.binance.org/en" target="_blank"><img style={{ position: 'absolute', right:20, top:10,  width:150, height:40 }} src={BLogo} alt="bscswap" /> </BinanceLogoLink>
                </BinanceLogo>
            </FooterFrame>
        </FooterBody>
    )}

export default Footer
